import { ReactComponent as Service } from 'assets/service.svg'
import { itIsToday, toShortDate, toTime } from 'utils/date'
import { Navigate } from 'hooks/useNavigateWithScrollSave'
import useTranslation from 'hooks/useTranslation'
import { selectChatThreads } from './chatSlice'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import Error from 'components/Error'

interface ChatListProps {
  mobile?: boolean
  showLabels?: boolean
  showOnlyActiveChats?: boolean
  showOnlyInactiveChats?: boolean
  navigate?: Navigate
}

const ChatList: React.FC<ChatListProps> = ({ mobile = true, showOnlyActiveChats = false, showOnlyInactiveChats = false, navigate }) => {
  const threads = useReduxSelector(selectChatThreads)
  const list = Object.values(threads)

  const { t, lang } = useTranslation('chat')
  const { push, replace } = useHistory()

  return (
    <div className='chat__list'>
      {list.length > 0
        ? list
          .filter(({ isClosed }) => {
            if (showOnlyActiveChats) return !isClosed
            else if (showOnlyInactiveChats) return !!isClosed
            return true
          })
          .map(({ id, type, call_time, datetime, started_at, isClosed, status, messages }) => {
            const lastMessage = type === 'chat' ? messages?.at(-1) : undefined
            const desc = type === 'chat' ? lastMessage?.message
              : status === 'INIT' ? t('missedCall')
                : status === 'CANCELLED' ? t('callEnded')
                  : `${t('durationOfConversation')}: ${call_time || t('0seconds')}`
            const isToday = itIsToday(datetime || started_at)
            const date = new Date(lastMessage?.datetime || datetime || started_at)

            return <div
              key={id}
              className='list__contact group'
              style={isClosed ? { opacity: 0.5 } : undefined}
              onClick={() => {
                if (type === 'chat') {
                  if (navigate) {
                    navigate(`/chat/${id}`, !mobile)
                  } else {
                    mobile ? push(`/chat/${id}`) : replace(`/chat/${id}`)
                  }
                }
              }}>

              <div className='contact__avatar center'>
                <Service className='service' />
              </div>

              <div className='contact__desc'>
                <div className='--secFont'>{t(type === 'chat' ? 'helpCenter' : 'conversationWithTechnicalSupport')}</div>
                <div className='chat__text'>{desc}</div>
              </div>

              <div className='contact__time chat__text'>
                {isToday
                  ? toTime(date, lang)
                  : toShortDate(date, lang)}
              </div>
            </div>
          })
        : <Error text={t('noMessages')} />}
    </div>
  )
}

export default ChatList